import { Pipe, PipeTransform } from "@angular/core";
import * as ContractDataModels from "./ContractDataModels";

@Pipe({ name: "contractStatus" })
export class ContractStatusPipe implements PipeTransform {
    transform(value: ContractDataModels.ContractStatusEnum): string {
        return ContractDataModels.ContractStatusEnum[value];
    }
}



// WEBPACK FOOTER //
// ./src/app/ContractManagement/ContractStatusPipe.ts